import styled from 'styled-components';
import { StyleColor, BaseStyledComponentProps, } from '../../../utils/styles-constants';

const driveItemRowImageSize = '150px';

interface ImageWrapperProps extends BaseStyledComponentProps {
	isActivated: boolean;
}

const RowSvgWrapper = styled('span')`
	border-radius: 9px 0 0 9px;/* TODO: configurable in admin from 0 to 9px */
	position: relative;
	background: ${StyleColor.Grey50};
	width: ${driveItemRowImageSize};
	height: ${driveItemRowImageSize};

	> svg {
		height: 60%;
		width: 60%;
		fill: ${StyleColor.Grey200};
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

const BlockWrapperStyle = `
	width: 100%;
	padding-top: 100%;
	height: 0;
	position: relative;
	text-align: center;
	overflow: hidden;
`;

const blockUnactiveBorder = (props: ImageWrapperProps) => `
	${!props.isActivated && `box-shadow: 0 9px 39px 1px rgba(0,0,0,0.1);` }
`;

const BlockSvgWrapper = styled('div')`
	${BlockWrapperStyle};
	border-radius: 9px;/* TODO: configurable in admin from 0 to 9px */
	${blockUnactiveBorder}

	:before {
		display: block;
		content: "";
		background-color: ${StyleColor.White};
		height: auto;
		width: 100%;
		border-radius: 9px;/* TODO: configurable in admin from 0 to 9px */

	}

	& > svg {
		width: 39%;
		height: 39%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		fill: ${StyleColor.Grey200};
	}
`;

const GridImageWrapper = styled('div')`
	${BlockWrapperStyle};
	${blockUnactiveBorder}
	border-radius: 9px;/* TODO: configurable in admin from 0 to 9px */
`;

const MasonryImageWrapper = styled('div')`
	width: 100%;
	height: auto;
	position: relative;
	border-radius: 9px;/* TODO: configurable in admin from 0 to 9px */
	background-color: ${StyleColor.White};
	${blockUnactiveBorder}
`;

const RowImageWrapper = styled('span')`
	background-color: ${StyleColor.Grey100};
	border-radius: 9px 0 0 9px;/* TODO: configurable in admin from 0 to 9px */
`;

const MasonryImage = styled('img')`
	width: 100%;
	min-height: 35px;
	height: auto;
	border-radius: 9px;/* TODO: configurable in admin from 0 to 9px */
	vertical-align: middle;
`;

interface BackgroundImageProps {
	imgURL: string;
}

const backgroundImage = (props: BackgroundImageProps) => `
	background-image: url('${props.imgURL}');
	background-size: cover;
	background-position: 50% 50%;
`;

const RowBackgroundImage = styled('div')`
	border-radius: 9px 0 0 9px;/* TODO: configurable in admin from 0 to 9px */
	width: ${driveItemRowImageSize};
	height: ${driveItemRowImageSize};
	flex-shrink: 0;
	${backgroundImage}
`;

const GridBackgroundImage = styled('div')`
	${backgroundImage}
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	height: 100%;
	border-radius: 9px;/* TODO: configurable in admin from 0 to 9px */
`;

export {
	GridImageWrapper,
	RowSvgWrapper,
	RowImageWrapper,
	RowBackgroundImage,
	BlockSvgWrapper,
	MasonryImage,
	MasonryImageWrapper,
	GridBackgroundImage,
	driveItemRowImageSize,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/Thumbnail/styles.ts